import { isPhone } from './base-init.js'

export function cloneSurvey () {
  const desktopCollapse = window.myvars.desktopCollapsePromoChannel == 1
  const mobileCollapse = window.myvars.mobileCollapsePromoChannel == 1
  let surveyBlock

  if (isPhone) {
    if (mobileCollapse) {
      surveyBlock = $('#SurveyPlaceholder--Hidden').find('.SurveyCollapse--block')
    } else {
      surveyBlock = $('#SurveyPlaceholder--Hidden').find('.SurveyNoCollapse--block')
    }
  } else {
    if (desktopCollapse) {
      surveyBlock = $('#SurveyDesktop--Showed').find('.SurveyCollapse--block')
    } else {
      surveyBlock = $('#SurveyDesktop--Showed').find('.SurveyNoCollapse--block')
    }
  }

  surveyBlock.appendTo('#survey-placeholder')
}

export function surveyBtnEffect () {
  const surveyItems = $('.survey-item-inline input')
  const surveyItemsLength = surveyItems.length
	console.debug('surveyBtnEffect')

  for (let i = 0; i < surveyItemsLength; i++) {
    const item = $(surveyItems[i])
    item.on('click', () => {
      // console.info('surveyBtnEffect')
      if (item.prop('checked')) {
        item
          .parent()
          .addClass('active')
      } else {
        item
          .parent()
          .removeClass('active')
      }
    })
  }
}

export function surveyBlockEffect () {
  const surveyCategoryItems = $('.CollapseCategory--Item')
  const surveyCategoryItemsLength = surveyCategoryItems.length

  for (let i = 0; i < surveyCategoryItemsLength; i++) {
    const item = $(surveyCategoryItems[i])
    const collapsible = item.find('.CollapseCategory--Row')
    collapsible
      .on('shown.bs.collapse', () => {
        // do something…
        // console.info('shown.bs.collapse')
        item.addClass('isActived')
      })
      .on('hidden.bs.collapse', () => {
        // do something…
        // console.info('shown.bs.collapse')
        item.removeClass('isActived')
      })
  }
}

window.surveyBtnEffect = surveyBtnEffect
// export default surveyBtnEffect
